import { css } from '@emotion/css';

import {
  Colors,
  FontSize,
  FontWeight,
  SMALL_DEVICE_MQ,
  Spacing,
} from '../../styles/constants';

export const labelValueClassName = css({
  display: 'flex',
  flexDirection: 'column',
});

export const labelClassName = css({
  color: Colors.Secondary,
  fontSize: FontSize.COMPACT,
  fontWeight: FontWeight.NORMAL,
  marginBottom: Spacing.XS,
});

export const valueClassName = css({
  color: Colors.Primary,
  fontSize: FontSize.REGULAR,
  fontWeight: FontWeight.SEMI_BOLD,
  [SMALL_DEVICE_MQ]: {
    fontSize: FontSize.COMPACT,
  },
});
